// com.sds.aisaas.common.enums.ReplyCode에 정의되어 있는 ReplyCode
const ReplyCode = {
	NO_ERROR: "0000",

	SIP_COUNT_NOT_ENOUGH: "1001",
	SIP_CHANNELS_OVER_CAPACITY: "1002",
	SIP_INVALID_NUMBER: "1003",
	
	SIP_GET_NUMBER_SUCCESS:"1000",
	SIP_GET_NUMBER_FAIL: "1001",
	SIP_USE_SUCCESS: "1002",
	SIP_NO_AGREE_TERMS_OF_USE: "1003",
	SIP_NO_AGREE_PERSONAL_INFO: "1004",
	SIP_UNAVAILABLE_NUMBER: "1005",
	SIP_OVER_CHANNEL_CAPACITY: "1006",
	SIP_NO_ENOUGH_CHANNEL_MIN_CAPACITY: "1007",
	SIP_INVALID_UNKNOWN: "1009",
	SIP_USE_FAIL: "1010",

	SCENARIO_NOT_COMPLETE_SCHEDULE: "2001",
	SCENARIO_INVALID_VARIABLE: "2002",
	SCENARIO_NAME_DUPLICATE: "2003",
	SCENARIO_NOT_COMPLETE: "2004",
	SCENARIO_NOT_OPERATING: "2005",
	SCENARIO_NOT_TESTABLE: "2006",
	SCENARIO_MODIFYING_BY_OTHER: "2020",
	
	SCHEDULE_STATUS_NOT_WAITING: "3001",
	EXIST_SCHEDULE_NAME: "3002",
	SITEID_NOT_FOUND: "3003",
	MODIFYING_BY_OTHER: "3004",

	FILE_UPLOAD_INVALID_TYPE: "4001",
	FILE_UPLOAD_EXCEED_SIZE: "4002",
	FILE_UPLOAD_EXCEED_QUANTITY: "4003",

	USER_INVITE_DUPLICATE_USER: "5001",
	USER_INVITE_EXCEED_MAX_ACCOUNT: "5002",
	USER_INVITE_ERROR: "5003",
	USER_ALREADY_REGISTERED: "5004",
	USER_NOT_UPDATABLE: "5101",
	
	LOGIN_TENANT_INCORRECT:	"6001",
	LOGIN_TENANT_NOT_USE: "6002",
	LOGIN_ID_PW_INCORRECT: "6003",
	LOGIN_USER_LOCKED: "6004",
	LOGIN_PW_NOT_MATCH_5: "6005",
	LOGIN_PW_EXPIRED: "6006",
	PW_CHANGE_TIME_EXPIRED: "6007",
	
	OTP_EXPIRED: "7001",
	OTP_NOT_MATCH: "7002",
	OTP_NOT_MATCH_5: "7003",
	OTP_ID_NOT_FOUND: "7004",
	OTP_VERIFY_EXPIRED: "7005",
	PW_INSECURE: "7006",
	PW_SAME: "7007",

	MSG_FAIL: "9996",
	MSG_ALT_DATA_NOT_FOUND: "9997",
	SYSTEM_ERROR: "9998",
	UNDEFINED_CODE: "9999",
  };
  
  export default ReplyCode;
  